import React from 'react'
import { Link } from 'react-router-dom'
import Headbar from '@app/components/shared/Headbar'
import LoginFormContainer from '@app/containers/Landing/LoginFormContainer'
import SVG from 'react-inlinesvg'
import kids from '@src/images/landing/kids_header'

const Header = ({ route, global }) => {
  let params = {}

  return (
    <div className="header-section">
      <div className="header-section__headbar">
        <Headbar
          global={global}
          route={route}
        />
      </div>
      <div className="header-section__content">
        <div className="grid grid--xl-2">
          <div className="w-flex-layout">
            <div className="w-flex-layout__top header-section__top" />
            <div className="w-flex-layout__center">
              <div className="w-flex-layout w-flex-layout--columns w-flex-layout--jc-center">
                <div className="header-section__logo">
                  <SVG src={global.event.logo} />
                </div>
                <h4 className="white f--white header-section__heading">
                  { I18n.t("landing.video_heading") }
                </h4>
                <p className="f--white mt-0 header-section__hint">
                  { I18n.t("landing.participants") }
                </p>
              </div>
            </div>
            <div className="w-flex-layout__bottom desktop-only header-section__bottom">
              <SVG src={kids} style={{ justifyContent: 'flex-end' }} />
            </div>
          </div>
          <div className="landing-form">
            <div className="hide-desktop header-section__mobile">
              <SVG src={kids} className="text-center" />
            </div>
            <div className="landing-form__content">
              <h3 className="landing-form__heading">
                { I18n.t('auth.heading') }
              </h3>
              <LoginFormContainer />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
